$(document).ready(function () {
    $('.div-click').click(function () {
        window.location = $(this).find('a').eq(0).attr('href');
    });
});
$(document).ready(function () {
    $('.div-click').hover(function () {
        $(this).css({'cursor': 'pointer'});
        // On peut ajouter ici d'autres modifications CSS au survol du bloc
    }, function () {
        // Ici, annuler les modifications CSS du survol.
        // Le curseur reprend sa forme automatiquement
    });
});

